import { Intervals } from '../types';

/**
 * Check if start and end inside any of passed intervals
 *
 * @param {Array<Array<number>>} intervals Array of intervals
 * @param {number} start Start of the checked segment
 * @param {number} end End of the checked segment
 * @returns {boolean} true if start and end inside any of passed intervals
 */
export function inIntervals(intervals: Intervals, start: number, end: number): boolean {
  for (const interval of intervals) {
    if (start >= interval[0] && end <= interval[1]) {
      return true;
    }
  }

  return false;
}
